export default [
  {
    path: "/f2cc731e-64bb-41d7-bb9f-53ba8dc194f1",
    children: [
      {
        path: "scores",
        name: "scoresList",
        component: () => import("@/views/scores/list.vue"),
        meta: {
          title: "Scores",
          authRequired: true,
          acc: ['y90342']
        },
      },
      {
        path: "new-score",
        name: "scoresNew",
        component: () => import("@/views/scores/upload-scores.vue"),
        meta: {
          title: "Upload Scores",
          authRequired: true,
          acc: ['y24808']
        },
      },
      {
        path: "vew-score",
        name: "viewScore",
        component: () => import("@/views/scores/view.vue"),
        meta: {
          title: "View School Scores",
          authRequired: true,
          acc: ['y95619']
        },
      },
      {
        path: "update-score",
        name: "scoresUpdate",
        component: () => import("@/views/scores/update-scores.vue"),
        meta: {
          title: "Update Scores",
          authRequired: true,
          acc: ['y51572']
        },
      },

    ],
  },
];
